import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabsTitleDirective } from './directives/tabs-title.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [TabsTitleDirective],
  exports: [TabsTitleDirective],
})
export class SharedFeatureTabsModule {}
